export const LIB_VERSION = '18.0.1'; // autogenerated
//# sourceMappingURL=version.js.map